// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"375":"eager-p0-core-components","551":"eager-p1-core-slices"}[chunkId] + "." + {"375":"3cb8a21e27ee54ede5ea","551":"6808904d5eb60093a2b3"}[chunkId] + ".css";
};